import * as React from 'react'

import './Preloader.scss'

interface PreloaderProps {
  hidden?: boolean
}

const Loader: React.FC<PreloaderProps> = props => {
  return (
    <div className={`srprs-loader ${props.hidden ? 'is-hidden' : ''}`}>
      <div className="dot" />
      <div className="shadow" />
    </div>
  )
}

export default Loader
